import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';

import { Transaction, useGameReducer, useUser } from '../../Store';
import { DATE_FORMAT, TIME_FORMAT } from '../../environment.config';
import Header from '../Header';
import { UserType } from '../../Utils';

export const TransactionDetails = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const gameReducer = useGameReducer();
  const [ transaction, setTransaction] = useState<Transaction>();
  const { id } = useParams();
  const user = useUser(useParams().userId);

  useEffect(() => {
    setTransaction(gameReducer.creditTransactions.find(v => v.id === id));
  }, [gameReducer.creditTransactions, id]);

  return (
    <>
      <Header name={t(transaction?.details !== 'Credit' ? 'transactions.withdrawCredit' : 'transactions.depositCredit')} agentMenu={true} />
      <div className='agent_body transaction_details'>
        {transaction && <>
          <div className="detail">
            <div className="logo">
              娱乐<span>60</span>秒 play<span>60</span>s
            </div>
            <div className="data">
              <div className="label">{t('transactions.vipRoom')}</div>
              <div className="value">{gameReducer.userDetail.displayName} {gameReducer.userDetail.displayName?'':`(${gameReducer.userDetail.name})`}</div>
            </div>
            <div className="data">
              <div className="label">{t('transactions.member')}</div>
              { user && user.user && (
                <div className="value">{user?.user?.name}</div>
              )}
              { !user && (
                <div className="value">{transaction.correspondingUsername} {transaction.correspondingDisplayName && (`(${transaction.correspondingDisplayName})`) }</div>
              )}
            </div>
            <div className="data">
              <div className="label">{t('transactions.date')}</div>
              <div className="value">{moment(transaction.created).format(DATE_FORMAT)}</div>
            </div>
            <div className="data">
              <div className="label">{t('transactions.time')}</div>
              <div className="value">{moment(transaction.created).format(TIME_FORMAT)}</div>
            </div>
            <div className="data">
              <div className="label">{t('transactions.id')}</div>
              <div className="value">{transaction.id}</div>
            </div>
            {transaction?.details === 'Credit' &&
              <div className="change_value">{t('transactions.deposited')} {
                transaction.debitAmount !== '0'
                  ? ('+' + transaction.debitAmount)
                  : ('+' + transaction.creditAmount)
              }</div>
            }
            {transaction?.details !== 'Credit' &&
              <div className="change_value">{t('transactions.withdrew')} {
                transaction.creditAmount !== '0'
                  ? ('-' + transaction.creditAmount)
                  : ('-' + transaction.debitAmount)
              }</div>
            }
          </div>

          {
            transaction?.accountId !== gameReducer.userDetail.id &&
              <button onClick={() => navigate(`${gameReducer.userDetail.role === UserType.AGENT ? '/Agent':'/Manager'}/Users/${user ? user.user?.id : `UserName/${transaction.correspondingUsername}`}`)}>{t('menu.memberProfile')}</button>
          }
        </>}
      </div>
    </>
  );
};
